export default __webpack_public_path__ + "static/media/screen6.ece06082.png";